import { useEffect, useRef, useState } from "react";

/**
 * Debounces a fast-changing value (e.g. search input) so consumers
 * (API calls, filters) only react after the user pauses typing.
 */
export function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}

/**
 * Returns the sessionStorage-parsed logged-in doctor/user object once,
 * memoized for the lifetime of the component.
 */
export function useLoggedInDoctor() {
  const ref = useRef(undefined);
  if (ref.current === undefined) {
    const json = sessionStorage.getItem("login_result");
    ref.current = json ? JSON.parse(json) : null;
  }
  return ref.current;
}